export default {"src":"/_next/static/media/visonumLogo.1d125cda.svg","height":25,"width":37};